import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState, mapActions } from "vuex";
export default {
  name: "d2-header-color",
  data: function data() {
    return {
      predefine: ["#ff4500", "#ff8c00", "#00ced1", "#1e90ff", "#c71585"]
    };
  },
  computed: _objectSpread({}, mapState("d2admin/color", ["value"])),
  watch: {
    value: function value(_value) {
      this.set(_value);
    }
  },
  methods: _objectSpread({}, mapActions("d2admin/color", ["set"]))
};